(function () {
  function sync_expanded(root) {
    root.querySelectorAll('.cf-widget-item').forEach(function (item) {
      var control = item.querySelector('.cf-accordion-title');
      if (!control) return;

      if (control.tagName !== 'BUTTON') {
        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
      }

      control.setAttribute('aria-expanded', item.classList.contains('closed') ? 'false' : 'true');
    });
  }

  function bind_accordion_a11y() {
    document.querySelectorAll('.cf-widget__accordion').forEach(function (accordion) {
      sync_expanded(accordion);

      if (accordion.dataset.cfA11yObserved === '1') return;
      accordion.dataset.cfA11yObserved = '1';

      var observer = new MutationObserver(function () {
        sync_expanded(accordion);
      });

      accordion.querySelectorAll('.cf-widget-item').forEach(function (item) {
        observer.observe(item, { attributes: true, attributeFilter: ['class'] });
      });
    });
  }

  function wire_keyboard() {
    document.addEventListener('keydown', function (event) {
      var control = event.target.closest('.cf-widget__accordion .cf-accordion-title');
      if (!control) return;

      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      control.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
    });
  }

  function init() {
    bind_accordion_a11y();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  wire_keyboard();
})();
